import { render, staticRenderFns } from "./SidebarBreakdown.vue?vue&type=template&id=6268dc64&scoped=true"
import script from "./SidebarBreakdown.vue?vue&type=script&lang=ts"
export * from "./SidebarBreakdown.vue?vue&type=script&lang=ts"
import style0 from "./SidebarBreakdown.vue?vue&type=style&index=0&id=6268dc64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6268dc64",
  null
  
)

export default component.exports